/*
 * Web chat (bot-ai vault/ws-web-chat.md), loaded from layout/theme.liquid on the contact page only.
 * Our panel (snippets/ss-chat-panel.liquid): the floating button and the contact page's chat card
 * (sections/ss-contact-methods.liquid) open it. The panel posts to the ss-web-chat worker:
 * {chat_id?, message} -> {ok, chat_id, replies[], restarted?}, refusals {ok:false, reason, message}.
 */
(function () {
  ours(document.querySelector('[data-ss-chat-open]'));

  function ours(card) {
    var GREETING = "Hi, I'm Sleek Space's AI assistant. I can price a floor, suggest lighting or check an order. What are you working on?";
    var STORE = 'ss-chat';
    var IDLE_MS = 20 * 60 * 1000; // the worker keeps a chat 20 minutes after its last message
    var LOCKS = ['chat_limit', 'visitor_limit', 'closed']; // real caps: the input closes
    var RETURNS = ['too_long', 'bad_request']; // the text goes back in the box to fix
    // Any other refusal (busy), a network failure or a reply that is not JSON keeps the text and offers a retry.
    var SHEET = window.matchMedia('(max-width: 749px), (max-height: 559px)');
    var CALM = window.matchMedia('(prefers-reduced-motion: reduce)');
    var MOUSE = window.matchMedia('(hover: hover) and (pointer: fine)');
    // Fixed bars and badges the button must clear wherever they show: the tile sticky add-to-cart, the
    // landing and article sticky CTAs, Google's merchant badge.
    var DOCKED = '#StickyAddToCartTiles.is-visible, .ss-sticky-cta.is-visible, .article-template__mobile-cta, #google-merchantwidget-iframe-wrapper';
    // Open menus and drawers that sit under the button's layer: it steps aside while they are open.
    var COVERS = '.section-header.menu-open, .header__search details[open], pickup-availability-drawer[open]';

    var fab = document.querySelector('[data-ss-chat-fab]');
    var root = document.querySelector('[data-ss-chat]');
    var panel = root.querySelector('.ss-chat__panel');
    var scroller = root.querySelector('[data-ss-chat-scroll]');
    var log = root.querySelector('[data-ss-chat-log]');
    var chips = root.querySelector('[data-ss-chat-chips]');
    var retry = root.querySelector('[data-ss-chat-retry]');
    var typing = root.querySelector('[data-ss-chat-typing]');
    var form = root.querySelector('[data-ss-chat-form]');
    var input = root.querySelector('[data-ss-chat-input]');
    var send = root.querySelector('[data-ss-chat-send]');
    var endpoint = root.getAttribute('data-endpoint');
    var state = load();
    var els = [];
    var busy = false;
    var opener = fab;
    var shift = 0;
    var queued = false;

    state.messages.forEach(render);
    if (state.messages.some(unsent)) state.failed = true; // left mid-send: offer the retry
    if (state.locked) lock();

    fab.hidden = false;
    fab.addEventListener('click', function () { open(fab); });
    if (card) card.addEventListener('click', function () { open(card); });
    root.querySelectorAll('[data-ss-chat-close]').forEach(function (el) { el.addEventListener('click', close); });
    root.addEventListener('cancel', function (e) { e.preventDefault(); close(); }); // Escape
    root.addEventListener('close', closed);
    chips.querySelectorAll('button').forEach(function (b) {
      b.addEventListener('click', function () { submit(b.textContent.trim()); input.focus(); });
    });
    retry.querySelector('button').addEventListener('click', function () { flush(); input.focus(); });
    form.addEventListener('submit', function (e) { e.preventDefault(); submitBox(); });
    input.addEventListener('input', function () { grow(); refresh(); });
    input.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' && !e.shiftKey && !e.isComposing) { e.preventDefault(); submitBox(); }
    });

    ['scroll', 'resize'].forEach(function (t) { window.addEventListener(t, schedule, { passive: true }); });
    document.addEventListener('click', schedule, true);
    document.addEventListener('transitionend', schedule, true);
    setInterval(place, 500); // a badge that mounts late (Google's) and bars that slide in
    place();

    // Keep the button clear of whatever is docked at the bottom of the screen on this page.
    function place() {
      queued = false;
      fab.classList.toggle('is-away', !!document.querySelector(COVERS));
      if (fab.hidden) return;
      var gap = 12;
      // A fixed element's offset box ignores its transform: where the button rests, even mid-lift.
      var left = fab.offsetLeft;
      var right = left + fab.offsetWidth;
      var top = fab.offsetTop;
      var bottom = top + fab.offsetHeight;
      var next = 0;
      document.querySelectorAll(DOCKED).forEach(function (el) {
        var r = el.getBoundingClientRect();
        if (!r.width || !r.height || getComputedStyle(el).visibility === 'hidden') return;
        if (r.left >= right + gap || r.right <= left - gap) return; // beside the button, not under it
        if (r.top >= bottom + gap || r.bottom <= top) return; // off screen, or above it
        next = Math.min(next, r.top - gap - bottom);
      });
      if (next === shift) return;
      shift = next;
      fab.style.transform = shift ? 'translateY(' + shift + 'px)' : '';
    }

    function schedule() {
      if (queued) return;
      queued = true;
      requestAnimationFrame(place);
    }

    function open(from) {
      opener = from;
      root.showModal();
      fab.hidden = true;
      document.documentElement.classList.add('ss-chat-open');
      if (!state.messages.length) add('agent', GREETING);
      refresh();
      fit();
      if (window.visualViewport) window.visualViewport.addEventListener('resize', fit);
      // A touch screen keeps its keyboard down until the visitor taps the box, so the greeting and chips stay in view.
      if (input.disabled) root.querySelector('.ss-chat__close').focus();
      else if (MOUSE.matches) input.focus();
      else panel.focus();
    }

    function close() {
      if (!root.open || root.classList.contains('is-closing')) return;
      if (CALM.matches) { root.close(); return; }
      root.classList.add('is-closing');
      setTimeout(function () { root.classList.remove('is-closing'); root.close(); }, 150);
    }

    function closed() {
      document.documentElement.classList.remove('ss-chat-open');
      if (window.visualViewport) window.visualViewport.removeEventListener('resize', fit);
      fab.hidden = false;
      place();
      opener.focus();
    }

    // Keep the panel inside the visible area while an on-screen keyboard is up: the phone sheet takes
    // the visible height, the tablet card rises above the keyboard.
    function fit() {
      var vv = window.visualViewport;
      if (!vv) return;
      var sheet = SHEET.matches;
      panel.style.height = sheet ? vv.height + 'px' : '';
      panel.style.top = sheet ? vv.offsetTop + 'px' : '';
      panel.style.setProperty('--ss-chat-kb', sheet ? '0px' : Math.max(0, Math.round(innerHeight - vv.offsetTop - vv.height)) + 'px');
      scroller.scrollTop = scroller.scrollHeight;
    }

    function grow() {
      input.style.height = '';
      input.style.height = Math.max(44, input.scrollHeight) + 'px';
    }

    function submitBox() {
      var text = input.value.trim();
      if (!text || input.disabled) return;
      input.value = '';
      grow();
      submit(text);
    }

    // A message typed while a reply is on its way waits its turn and goes when the reply lands.
    function submit(text) {
      add('user', text, true);
      if (busy) refresh();
      else flush();
    }

    function flush() {
      var m = state.messages.filter(unsent)[0];
      if (!m || busy || state.locked) return;
      busy = true;
      state.failed = false;
      refresh();
      var body = state.chatId ? { chat_id: state.chatId, message: m.text } : { message: m.text };
      fetch(endpoint, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body) })
        .then(function (res) {
          return res.json().catch(function () { throw new Error('chat answered ' + res.status + ' without JSON'); });
        })
        .then(function (data) {
          if (data.ok) {
            m.unsent = false;
            if (data.restarted) add('note', 'That chat timed out, so this one starts fresh.');
            state.chatId = data.chat_id;
            data.replies.forEach(function (r) { add('agent', r); });
          } else if (LOCKS.indexOf(data.reason) >= 0) {
            console.error('[ss-chat] refused:', data.reason);
            add('note', data.message); // the worker's wording points at the form on this page
            lock();
          } else if (RETURNS.indexOf(data.reason) >= 0) {
            console.error('[ss-chat] refused:', data.reason);
            drop(m);
            add('note', data.message);
            if (!input.value) { input.value = m.text; grow(); }
          } else {
            throw new Error('refused: ' + data.reason);
          }
        })
        .catch(function (err) {
          // Never retried by itself: the worker may already have posted it to Retell. The visitor decides.
          console.error('[ss-chat]', err);
          state.failed = true;
        })
        .then(function () {
          busy = false;
          save();
          refresh();
          if (!state.failed) flush();
        });
    }

    function lock() {
      state.locked = true;
      input.disabled = true;
      input.placeholder = 'Chat is closed for now';
      refresh();
    }

    // Everything around the messages follows the state: chips, retry, typing dots, the send button.
    function refresh() {
      var asked = state.messages.some(function (m) { return m.role === 'user'; });
      chips.hidden = asked || state.locked || !state.messages.length;
      retry.hidden = !state.failed || busy || state.locked;
      typing.hidden = !busy;
      els.forEach(function (el, i) { el.classList.toggle('is-unsent', !!state.messages[i].unsent && !busy); });
      send.disabled = input.disabled || !input.value.trim();
      scroller.scrollTop = scroller.scrollHeight;
    }

    function unsent(m) { return m.unsent; }

    function add(role, text, pending) {
      var m = { role: role, text: text };
      if (pending) m.unsent = true;
      state.messages.push(m);
      render(m);
      save();
    }

    function drop(m) {
      var i = state.messages.indexOf(m);
      state.messages.splice(i, 1);
      els.splice(i, 1)[0].remove();
    }

    function render(m) {
      var el = document.createElement('div');
      el.className = 'ss-chat__msg ss-chat__msg--' + m.role;
      linkify(el, m.text);
      log.appendChild(el);
      els.push(el);
    }

    // Text nodes only; a full https address opens in a new tab, the phone number dials.
    function linkify(el, text) {
      var re = /https:\/\/[^\s<>"]+|1300 148 799/g;
      var at = 0;
      var match;
      while ((match = re.exec(text))) {
        var found = match[0].replace(/[.,;:!?)]+$/, '');
        var a = document.createElement('a');
        if (found.charAt(0) === 'h') {
          a.href = found;
          a.textContent = found.replace(/^https:\/\/(www\.)?/, '');
          a.target = '_blank';
          a.rel = 'noopener nofollow';
        } else {
          a.href = 'tel:1300148799';
          a.textContent = found;
        }
        el.appendChild(document.createTextNode(text.slice(at, match.index)));
        el.appendChild(a);
        at = match.index + found.length;
        re.lastIndex = at;
      }
      el.appendChild(document.createTextNode(text.slice(at)));
    }

    function load() {
      try {
        var s = JSON.parse(sessionStorage.getItem(STORE));
        if (s && Date.now() - s.at < IDLE_MS) return s;
      } catch (e) { /* storage blocked or empty: start a new chat */ }
      return { chatId: null, messages: [], locked: false, failed: false, at: Date.now() };
    }

    function save() {
      state.at = Date.now();
      try { sessionStorage.setItem(STORE, JSON.stringify(state)); } catch (e) { /* storage blocked: the chat still works */ }
    }
  }
})();
